<div class="tt-paginator_size-selector">
  <tt-select [(ngModel)]="_itemsPerPage" (selectionChanged)="handlePageSizeChanged($event)">
    <tt-select-items>
      @for (pageSizeOption of pageSizeOptions; track pageSizeOption) {
        <tt-option [value]="pageSizeOption">{{ pageSizeOption }}</tt-option>
      }
    </tt-select-items>
  </tt-select>
</div>
<div class="tt-paginator_page-indicator">
  {{ 'Paginator.PageOf' | transloco: { page: _page(), total: numberOfPages() === 0 ? 1 : numberOfPages() } }}
</div>
<div class="tt-paginator_steppers">
  <mat-icon
    class="tt-paginator_stepper tt-paginator_stepper-first-page"
    [class.tt-paginator_stepper--disabled]="_page() === 1"
    [icon]="'chevron-first'"
    [iconSize]="22"
    (click)="handleFirstPageClicked()" />
  <mat-icon
    class="tt-paginator_stepper"
    [class.tt-paginator_stepper--disabled]="_page() === 1"
    [icon]="'chevron-left'"
    [iconSize]="22"
    (click)="handlePreviousPageClicked()" />
  <mat-icon
    class="tt-paginator_stepper"
    [class.tt-paginator_stepper--disabled]="_page() >= numberOfPages()"
    [icon]="'chevron-right'"
    [iconSize]="22"
    (click)="handleNextPageClicked()" />
  <mat-icon
    class="tt-paginator_stepper tt-paginator_stepper-last-page"
    [class.tt-paginator_stepper--disabled]="_page() >= numberOfPages()"
    [icon]="'chevron-last'"
    [iconSize]="22"
    (click)="handleLastPageClicked()" />
</div>
